import React, { Component } from 'react'
import API_URL from '../../../common/url';
import ProjectMonSta from '../components/ProjectMonSta'

const panes = [{
  title: 'JDE主项目号分析',
  key: 'JdeMainProjectNum',
  columns: [{
    title: 'JDE主项目号',
    dataIndex: 'jdeMainCode',
    key: 'jdeMainCode',
    fixed: 'left',
    width: 120,
}, {
    title: '项目简称',
    dataIndex: 'investigationName',
    key: 'investigationName',
    width: 160,
}, {
    title: '项目阶段',
    dataIndex: 'stageNames',
    key: 'stageNames',
    width: 160,
}, {
    title: '业务线',
    dataIndex: 'lineOfBusinessString',
    key: 'lineOfBusinessString',
    width: 80,
}, {
    title: '执行业务线二级分类',
    dataIndex: 'secondLineName',
    key: 'secondLineName',
    width: 120,
}, {
    title: '项目分类',
    dataIndex: 'investigationTypeName',
    key: 'investigationTypeName',
    width: 100,
}, {
    title: '项目领域',
    dataIndex: 'investigationAreaName',
    key: 'investigationAreaName',
    width: 100,
}, {
    title: '疾病',
    dataIndex: 'diseaseName',
    key: 'diseaseName',
    width: 100,
}, {
    title: '领域leader',
    dataIndex: 'leaderNameCode',
    key: 'leaderNameCode',
    width: 120,
}, {
    title: '项目经理工号',
    dataIndex: 'pmCode',
    key: 'pmCode',
    width: 100,
}, {
    title: '项目经理姓名',
    dataIndex: 'pmUser',
    key: 'pmUser',
    width: 100,
  }, {
    title: '实际启动数',
    dataIndex: 'startSiteNum',
    key: 'startSiteNum',
    width: 100,
  }, {
    title: '津石计划负责中心数量',
    dataIndex: 'jsPlanSiteNum',
    key: 'jsPlanSiteNum',
    width: 100,
  }, {
    title: '合同计划负责中心数量',
    dataIndex: 'contractSitePlanAmount',
    key: 'contractSitePlanAmount',
    width: 100,
  }, {
    title: '启动比例',
    dataIndex: 'siteStartRate',
    key: 'siteStartRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }, {
    title: '累计完成访视数',
    dataIndex: 'visitAmount',
    key: 'visitAmount',
    width: 100,
  }, {
    title: '津石计划访视数量',
    dataIndex: 'jsPlanAmount',
    key: 'jsPlanAmount',
    width: 100,
  }, {
    title: '合同计划访视数量',
    dataIndex: 'contractPlanAmount',
    key: 'contractPlanAmount',
    width: 100,
  }, {
    title: '访视比例',
    dataIndex: 'visitAmountRate',
    key: 'visitAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }, {
    title: '累计已确认标准访视数',
    dataIndex: 'visitStandardAmount',
    key: 'visitStandardAmount',
    width: 100,
  }, {
    title: '津石计划标准访视数量',
    dataIndex: 'jsPlanStandardAmount',
    key: 'jsPlanStandardAmount',
    width: 100,
  }, {
    title: '合同计划标准访视数量',
    dataIndex: 'contractStandardAmount',
    key: 'contractStandardAmount',
    width: 100,
  }, {
    title: '标访比例',
    dataIndex: 'visitStandardAmountRate',
    key: 'visitStandardAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }, {
    title: '累计随机数',
    dataIndex: 'randomAmount',
    key: 'randomAmount',
    width: 100,
  }, {
    title: '津石计划随机（入组）数量',
    dataIndex: 'jsPlanRandomAmount',
    key: 'jsPlanRandomAmount',
    width: 100,
  }, {
    title: '合同计划随机（入组）数量',
    dataIndex: 'contractRandomPlanAmount',
    key: 'contractRandomPlanAmount',
    width: 100,
  }, {
    title: '入组比例',
    dataIndex: 'randomAmountRate',
    key: 'randomAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }, {
    title: '已发起请款金额',
    dataIndex: 'remittanceAmount',
    key: 'remittanceAmount',
    width: 100,
  }, {
    title: '合同约定请款金额',
    dataIndex: 'contractRemittanceAmount',
    key: 'contractRemittanceAmount',
    width: 100,
  }, {
    title: '合同额含税/人民币（服务费）',
    dataIndex: 'jdeContractAmount',
    key: 'jdeContractAmount',
    width: 120,
  }, {
    title: '请款比例（含税）',
    dataIndex: 'remittanceAmountRate',
    key: 'remittanceAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }, {
    title: '累计含税开票金额（服务费）',
    dataIndex: 'grossAmount',
    key: 'grossAmount',
    width: 120,
  }, {
    title: '开票比例（服务费）',
    dataIndex: 'grossAmountRate',
    key: 'grossAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }, {
    title: '累计含税回款金额（服务费）',
    dataIndex: 'receivingAmount',
    key: 'receivingAmount',
    width: 120,
  }, {
    title: '回款比例（服务费）',
    dataIndex: 'receivingAmountRate',
    key: 'receivingAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }, {
    title: '累计收入不含税/人民币',
    dataIndex: 'cnyTotalIncomeNoTax',
    key: 'cnyTotalIncomeNoTax',
    width: 100,
  }, {
    title: '确认收入比例',
    dataIndex: 'cnyTotalIncomeNoTaxRate',
    key: 'cnyTotalIncomeNoTaxRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }],
}, {
  title: 'JDE项目号分析',
  key: 'JdeProjectNum',
  columns: [{
    title: 'JDE主项目号',
    dataIndex: 'jdeMainCode',
    key: 'jdeMainCode',
    fixed: 'left',
    width: 120,
}, {
  title: 'JDE项目号',
  dataIndex: 'investigationJdeContractCode',
  key: 'investigationJdeContractCode',
  width: 120,
}, {
    title: '项目简称',
    dataIndex: 'investigationName',
    key: 'investigationName',
    width: 160,
}, {
    title: '项目阶段',
    dataIndex: 'stageNames',
    key: 'stageNames',
    width: 160,
}, {
    title: '业务线',
    dataIndex: 'lineOfBusinessString',
    key: 'lineOfBusinessString',
    width: 80,
}, {
    title: '执行业务线二级分类',
    dataIndex: 'secondLineName',
    key: 'secondLineName',
    width: 120,
}, {
    title: '项目分类',
    dataIndex: 'investigationTypeName',
    key: 'investigationTypeName',
    width: 100,
}, {
    title: '项目领域',
    dataIndex: 'investigationAreaName',
    key: 'investigationAreaName',
    width: 100,
}, {
    title: '疾病',
    dataIndex: 'diseaseName',
    key: 'diseaseName',
    width: 100,
}, {
    title: '领域leader',
    dataIndex: 'leaderNameCode',
    key: 'leaderNameCode',
    width: 120,
}, {
    title: '项目经理工号',
    dataIndex: 'pmCode',
    key: 'pmCode',
    width: 100,
}, {
    title: '项目经理姓名',
    dataIndex: 'pmUser',
    key: 'pmUser',
    width: 100,
},{
    title: '已发起请款金额',
    dataIndex: 'remittanceAmount',
    key: 'remittanceAmount',
    width: 100,
}, {
    title: '合同约定请款金额',
    dataIndex: 'contractRemittanceAmount',
    key: 'contractRemittanceAmount',
    width: 100,
}, {
    title: '合同额含税/人民币（服务费）',
    dataIndex: 'jdeContractAmount',
    key: 'jdeContractAmount',
    width: 120,
}, {
    title: '请款比例（含税）',
    dataIndex: 'remittanceAmountRate',
    key: 'remittanceAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
}, {
    title: '累计开票金额（服务费）',
    dataIndex: 'grossAmount',
    key: 'grossAmount',
    width: 120,
}, {
    title: '开票比例（服务费）',
    dataIndex: 'grossAmountRate',
    key: 'grossAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
}, {
    title: '累计回款金额（服务费）',
    dataIndex: 'receivingAmount',
    key: 'receivingAmount',
    width: 120,
}, {
    title: '回款比例（服务费）',
    dataIndex: 'receivingAmountRate',
    key: 'receivingAmountRate',
    width: 100,
    render: text => text ? text + '%' : ''
}, {
    title: '累计收入不含税/人民币',
    dataIndex: 'cnyTotalIncomeNoTax',
    key: 'cnyTotalIncomeNoTax',
    width: 100,
}, {
    title: '确认收入比例',
    dataIndex: 'cnyTotalIncomeNoTaxRate',
    key: 'cnyTotalIncomeNoTaxRate',
    width: 100,
    render: text => text ? text + '%' : ''
  }],
},]
const config = {
  loadDataUrl: API_URL.dashboard.queryInvVisitContractDataList,
  exportUrl: API_URL.dashboard.exportInvVisitContractDataList,
}

export default class VisitInCashMakeReturn extends Component {
  render() {
    const { title } = this.props
    return (
      <ProjectMonSta title={title} panes={panes} activeKey={'JdeMainProjectNum'} config={config} exportModal={true} searchTime={false} specialTip={true}/>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/homePage/statement/visitInCashMakeReturn.js